import { render, staticRenderFns } from "./tabs_with_list.vue.js?vue&type=template&id=f108b432!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./tabs_with_list.vue?vue&type=template&id=f108b432"
import script from "./tabs_with_list.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./tabs_with_list.vue?vue&type=script&lang=js"
export * from "./tabs_with_list.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./tabs_with_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/gitlab-gdk/gitlab-development-kit/gitlab/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f108b432')) {
      api.createRecord('f108b432', component.options)
    } else {
      api.reload('f108b432', component.options)
    }
    module.hot.accept("./tabs_with_list.vue.js?vue&type=template&id=f108b432!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./tabs_with_list.vue?vue&type=template&id=f108b432", function () {
      api.rerender('f108b432', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "groups_projects/components/tabs_with_list.vue"
export default component.exports